import React from "react";
import { FaUser } from "react-icons/fa";
import cadillacXTS from "../assets/images/Cadillac XTS.png";
import lincolnMKT from "../assets/images/Lincoln MKT.png";
import cadillacEscalade from "../assets/images/Cadillac Escalade.png";
import mercedesSprinter from "../assets/images/Mercedes Sprinter.png";

const fleetVehicles = [
  {
    id: 1,
    title: "Cadillac XTS",
    passengers: 4,
    description:
      "Experience the refined style of the Cadillac XTS, ideal for local trips and airport transfers.",
    image: cadillacXTS,
  },
  {
    id: 2,
    title: "Lincoln MKT",
    passengers: 5,
    description:
      "Ride in style with the Lincoln MKT, offering comfort and elegance for every journey.",
    image: lincolnMKT,
  },
  {
    id: 3,
    title: "Cadillac Escalade",
    passengers: 7,
    description:
      "The Cadillac Escalade provides unmatched luxury and spacious interiors for a premium experience.",
    image: cadillacEscalade,
  },
  {
    id: 4,
    title: "Mercedes Sprinter",
    passengers: 15,
    description:
      "Perfect for group travels and special events, the Mercedes Sprinter offers plenty of space and top safety features.",
    image: mercedesSprinter,
  },
];

export default function Fleet() {
  return (
    <>
      <style>{`
        /* Modern 2025-inspired styling */
        .fleet-card {
          transition: transform 0.4s ease, box-shadow 0.4s ease;
          cursor: pointer;
          position: relative;
          overflow: hidden;
          border-radius: 20px;
        }
        .fleet-card:hover {
          transform: scale(1.05);
          box-shadow: 0 15px 25px rgba(0,0,0,0.3);
        }
        .fleet-card:hover .hoverOverlay {
          opacity: 1;
        }
        .quote-button {
          transition: background-color 0.3s ease;
        }
        .quote-button:hover {
          background-color: #00b1ff;
        }
        .hoverOverlay {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background: rgba(15, 22, 36, 0.7);
          opacity: 0;
          transition: opacity 0.3s ease;
          display: flex;
          align-items: center;
          justify-content: center;
          color: white;
          text-align: center;
          font-size: 1.4rem;
          font-weight: bold;
        }
        .overlayContent {
          font-family: 'Helvetica Neue', sans-serif;
          text-transform: uppercase;
        }
        .descriptionTitle {
          font-size: 2.5rem;
          font-weight: bold;
          color: #203a43;
          text-align: center;
          margin-bottom: 10px;
          text-transform: uppercase;
        }
      `}</style>

      <div style={styles.container}>
        <div style={styles.descriptionBar}>
          <h2 className="descriptionTitle">Fleet at Heritage Car Airport</h2>
          <p style={styles.descriptionText}>
            Heritage Car Airport delivers premium, reliable transportation services
            for local trips and airport transfers. Our fleet is continuously updated,
            ensuring every vehicle is clean, luxurious, and safe.
          </p>
        </div>

        <div style={styles.fleetGrid}>
          {fleetVehicles.map((vehicle) => (
            <div key={vehicle.id} className="fleet-card" style={styles.card}>
              <div style={styles.topStripe}>
                <span style={styles.cardTitle}>{vehicle.title}</span>
                <div style={styles.passengerInfo}>
                  <FaUser style={{ marginRight: 5 }} />
                  <span>{vehicle.passengers}</span>
                </div>
              </div>

              <div style={styles.imageContainer}>
                <img
                  src={vehicle.image}
                  alt={vehicle.title}
                  style={styles.cardImage}
                />
                <div className="hoverOverlay">
                  <div className="overlayContent">
                    <span>{vehicle.title}</span>
                    <br />
                    <span>9142762961</span>
                  </div>
                </div>
              </div>

              <div style={styles.cardBody}>
                <p style={styles.description}>{vehicle.description}</p>
              </div>

              <button className="quote-button" style={styles.quoteButton}>
                GET A QUOTE NOW!
              </button>
            </div>
          ))}
        </div>
      </div>
    </>
  );
}

const styles = {
  container: {
    padding: "40px",
    background: "#f5f5f5",
  },
  descriptionBar: {
    textAlign: "center",
    marginBottom: "30px",
    padding: "10px 20px",
  },
  descriptionText: {
    fontSize: "1rem",
    lineHeight: 1.4,
    maxWidth: "800px",
    margin: "auto",
    color: "#2B3F50",
  },
  fleetGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
    gap: "20px",
  },
  card: {
    backgroundColor: "#fff",
    borderRadius: "20px",
    boxShadow: "0 6px 12px rgba(0, 0, 0, 0.1)",
    display: "flex",
    flexDirection: "column",
  },
  topStripe: {
    height: "60px",
    /* We'll revert to the earlier 2025 style gradient: #0f2027, #203a43, #2c5364 */
    background: "linear-gradient(to right, #0f2027, #203a43, #2c5364)",
    color: "#fff",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "0 15px",
    borderTopLeftRadius: "20px",
    borderTopRightRadius: "20px",
  },
  cardTitle: {
    fontSize: "1rem",
    fontWeight: "bold",
    textTransform: "uppercase",
  },
  passengerInfo: {
    display: "flex",
    alignItems: "center",
    fontWeight: "bold",
    fontSize: "1rem",
  },
  imageContainer: {
    position: "relative",
  },
  cardImage: {
    width: "100%",
    height: "220px",
    objectFit: "cover",
  },
  cardBody: {
    padding: "20px",
    flex: 1,
  },
  description: {
    fontSize: "0.9rem",
    color: "#555",
    lineHeight: "1.4",
  },
  quoteButton: {
    backgroundColor: "#0066cc",
    color: "#fff",
    padding: "12px 16px",
    borderRadius: "10px",
    cursor: "pointer",
    fontSize: "1rem",
    margin: "20px",
    border: "none",
  },
};
